import { TYPE_WRAPPER } from '../constants/type-wrapper.const.mjs';
export function isTypeWrapper(x) {
    return x[TYPE_WRAPPER] === 0 /* TypeWrapperStamp.Generic */;
}
//# sourceMappingURL=is-type-wrapper.util.mjs.map